import React, { useState, useMemo } from "react";
import { IoSearchOutline } from "react-icons/io5";
import userProfile1 from '../../assets/images/userProfile1.png'
import userProfile2 from '../../assets/images/userProfile2.png'
import userProfile3 from '../../assets/images/userProfile3.png'
import userProfile4 from '../../assets/images/userProfile4.png'
import userProfile5 from '../../assets/images/userProfile5.png'
import userProfile6 from '../../assets/images/userProfile6.png'
import ShareModal from "../games/auxiliary/ShareModal";


const users = [
    {
        name: 'SteshaCr',
        wins: 230,
        profile: userProfile1,
        bgClass: 'bg-FD8D84',
        category: 'wins',
        email: 'steshacr@gmail.com',
        country: 'Nigeria',
        favGame: 'Chess',
        bio: `I'm SteshaCr, hailing from Lagos, Nigeria, where I've carved a niche for myself in the gaming world. My journey began with a love for strategic classics like Chess and Ludo, which not only honed my tactical abilities but also opened doors to a vibrant, global gaming community. As I climbed the ranks in local tournaments, my belief in gaming as a bridge between cultures has only strengthened. I'm committed to mastering my skills further and making an impact in Nigeria's competitive gaming landscape.`
    },
    {
        name: 'JosephX',
        wins: 300,
        profile: userProfile2,
        bgClass: 'bg-84FDA6',
        category: 'wins',
        email: 'josephx@gmail.com',
        country: 'Nigeria',
        favGame: 'Scrabble',
        bio: `I'm JosephX, hailing from Lagos, Nigeria, where I've carved a niche for myself in the gaming world. My journey began with a love for strategic classics like Chess and Ludo, which not only honed my tactical abilities but also opened doors to a vibrant, global gaming community. As I climbed the ranks in local tournaments, my belief in gaming as a bridge between cultures has only strengthened. I'm committed to mastering my skills further and making an impact in Nigeria's competitive gaming landscape.`
    },
    {
        name: 'DaniX',
        wins: 150,
        profile: userProfile3,
        bgClass: 'bg-B1DEFF',
        category: 'wins',
        email: 'danix@gmail.com',
        country: 'Nigeria',
        favGame: 'Ludo',
        bio: `I'm DaniX, hailing from Lagos, Nigeria, where I've carved a niche for myself in the gaming world. My journey began with a love for strategic classics like Chess and Ludo, which not only honed my tactical abilities but also opened doors to a vibrant, global gaming community. As I climbed the ranks in local tournaments, my belief in gaming as a bridge between cultures has only strengthened. I'm committed to mastering my skills further and making an impact in Nigeria's competitive gaming landscape.`
    },
    {
        name: 'Clar8',
        wins: 20,
        profile: userProfile4,
        bgClass: 'bg-C59AFC',
        category: 'new',
        email: 'clar8@gmail.com',
        country: 'Nigeria',
        favGame: 'Chess',
        bio: `I'm Clar8, hailing from Lagos, Nigeria, where I've carved a niche for myself in the gaming world. My journey began with a love for strategic classics like Chess and Ludo, which not only honed my tactical abilities but also opened doors to a vibrant, global gaming community. As I climbed the ranks in local tournaments, my belief in gaming as a bridge between cultures has only strengthened. I'm committed to mastering my skills further and making an impact in Nigeria's competitive gaming landscape.`
    },
    {
        name: 'James Dan',
        wins: 100,
        profile: userProfile5,
        bgClass: 'bg-FFD2B1',
        category: 'old',
        email: 'jamesdan@gmail.com',
        country: 'Nigeria',
        favGame: 'Scrabble',
        bio: `I'm James Dan, hailing from Lagos, Nigeria, where I've carved a niche for myself in the gaming world. My journey began with a love for strategic classics like Chess and Ludo, which not only honed my tactical abilities but also opened doors to a vibrant, global gaming community. As I climbed the ranks in local tournaments, my belief in gaming as a bridge between cultures has only strengthened. I'm committed to mastering my skills further and making an impact in Nigeria's competitive gaming landscape.`        
    },
    {
        name: 'Diamond',
        wins: 60,
        profile: userProfile6,
        bgClass: 'bg-C5F8FF',
        category: 'rookies',
        email: 'diamond@gmail.com',
        country: 'Nigeria',
        favGame: 'Ludo',
        bio: `I'm Diamond, hailing from Lagos, Nigeria, where I've carved a niche for myself in the gaming world. My journey began with a love for strategic classics like Chess and Ludo, which not only honed my tactical abilities but also opened doors to a vibrant, global gaming community. As I climbed the ranks in local tournaments, my belief in gaming as a bridge between cultures has only strengthened. I'm committed to mastering my skills further and making an impact in Nigeria's competitive gaming landscape.`
    },
]



export default function InviteFriends(){
    const [searchQuery, setSearchQuery] = useState('');
    const [shareModal, setShareModal] = useState({ visible: false, onHide: null, size: 'md' })
    const [importedContacts, setImportedContacts] = useState([]);
    const [contactsError, setContactsError] = useState(null);

    const openShareModal = () => setShareModal({ visible: true, onHide: hideShareModal, size: 'md'})
    const hideShareModal = () => setShareModal({ visible: false, onHide: null, size: 'md'})

    const filteredUsers = useMemo(() => {
        if (!searchQuery) return users;
        
        const query = searchQuery.toLowerCase();
        return users.filter(user => 
            user.name.toLowerCase().includes(query) ||
            user.email.toLowerCase().includes(query) ||
            user.country.toLowerCase().includes(query) ||
            user.favGame.toLowerCase().includes(query)
        );
    }, [searchQuery]);

    // Handler for importing contacts
const handleImportContacts = async () => {
    setContactsError(null);
    setImportedContacts([]);

    if (!("contacts" in navigator)) {
        setContactsError(
            "Importing contacts is not supported in your browser. " +
            "Try using Chrome or Edge on Android, or a device that supports the Contacts Picker API."
        );
        return;
    }
    if (!window.isSecureContext) {
        setContactsError("Contacts API only works on HTTPS or localhost.");
        return;
    }
    try {
        const props = ["name", "email", "tel"];
        const opts = { multiple: true };
        const contacts = await navigator.contacts.select(props, opts);
        if (contacts && contacts.length > 0) {
            setImportedContacts(contacts);
        } else {
            setContactsError("No contacts selected or permission denied.");
        }
    } catch (err) {
        // This 'err' object is crucial for debugging
        setContactsError(
            (err && err.message) ||
            "Failed to access contacts or permission denied. Please check browser permissions."
        );
        console.error("Contacts API error:", err); // Log the error for more details
    }
};

    return (
        <div className='invite-friends scrollbar-hide'>
            <div className="invite-friends__header">
                <h1 className="invite-friends__title">
                    Invite <span className="invite-friends__title-highlight">Friends</span>
                </h1>
            </div>

            <div className="invite-friends__search">
                <input
                    type="text"
                    placeholder="Search by name, email, country, or favorite game..."
                    className="invite-friends__search-input"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
                <IoSearchOutline className="invite-friends__search-icon" size={20} />
            </div>

            <div className="invite-friends__users">
                {filteredUsers.map((user, index) => (
                    <div key={index} className="invite-friends__user-card d-flex align-items-center">
                        <div className={`invite-friends__user-avatar ${user.bgClass}`}>
                            <img src={user.profile} alt={user.name} className="w-100 h-100" />
                        </div>
                        <div className="invite-friends__user-info">
                            <h3 className="invite-friends__user-name">{user.name}</h3>
                            <p className="invite-friends__user-details">
                                {user.favGame} • {user.country}
                            </p>
                        </div>
                        <button 
                            className="invite-friends__invite-btn"
                            onClick={openShareModal}
                        >
                            Invite
                        </button>
                    </div>
                ))}

                {filteredUsers.length === 0 && (
                    <div className="text-center text-white opacity-75 py-4">
                        No users found matching your search.
                    </div>
                )}
            </div>

            <div className="flex items-center gap-3 mb-4">
                <button
                    className="invite-friends__invite-btn"
                    style={{ background: "#3F9217", color: "#fff", fontWeight: 600 }}
                    onClick={handleImportContacts}
                >
                    Import from Contacts
                </button>
                {contactsError && (
                    <span className="text-red-400 text-xs">{contactsError}</span>
                )}
            </div>
            {importedContacts.length > 0 && (
                <div className="invite-friends__imported-contacts mb-4">
                    <div className="font-bold text-white mb-2">Imported Contacts:</div>
                    {importedContacts.map((contact, idx) => (
                        <div key={idx} className="flex items-center gap-2 bg-[#1F0A35] rounded-lg p-2 mb-1">
                            <span className="text-white font-medium">{contact.name?.[0] || "No Name"}</span>
                            {contact.email?.[0] && (
                                <span className="text-gray-400 text-xs">{contact.email[0]}</span>
                            )}
                            {contact.tel?.[0] && (
                                <span className="text-gray-400 text-xs">{contact.tel[0]}</span>
                            )}
                            {/* Optionally, add an Invite button here */}
                        </div>
                    ))}
                </div>
            )}

            <ShareModal modalProps={shareModal} />
        </div>
    )
}